export const WIDGET_COLORS = {
  primary: '#4b3e6d',
  primaryHover: '#3a3055',
  primaryLight: 'rgba(75,62,109,0.12)',
  primaryDivider: 'rgba(75,62,109,0.15)',
  nearBlack: '#171717',
  divider: '#f0f0f4',
  dustBlue: '#a4c5d0',
  salmon: '#e58074',
  green: {
    bg: '#e8f6ef',
    text: '#1b4230',
    bar: '#2e7d52',
    divider: 'rgba(27,66,48,0.15)',
  },
  amber: {
    bg: '#fff8e6',
    text: '#7a4a00',
    bar: '#f0a500',
    divider: 'rgba(122,74,0,0.15)',
  },
  red: {
    bg: '#fff0f0',
    text: '#c0392b',
    hover: '#a93226',
    divider: 'rgba(192,57,43,0.15)',
  },
  dip: {
    bg: '#e8f0fb',
    text: '#1a3a6b',
    labelText: '#6680a8',
    bar: '#5b8def',
    divider: 'rgba(26,58,107,0.15)',
  },
  purple: {
    bg: '#f5f0ff',
    text: '#332554',
  },
  community: {
    pillBg: 'rgba(164,197,208,0.2)',
    pillText: '#1f6878',
  },
  bonus: {
    bar: '#f59e0b',
    pillBg: '#fff3e0',
    pillText: '#b45309',
  },
  referral: {
    bar: '#8b5cf6',
    pillBg: '#ede9fe',
    pillText: '#5b21b6',
  },
  gray: {
    bg: '#ebecf0',
    statBg: '#f7f7fa',
    bar: '#c8c8d0',
    legendBg: 'rgba(200,200,208,0.2)',
    text: '#888',
    mid: '#444',
    muted: '#666',
    locked: '#aaa',
    divider: 'rgba(0,0,0,0.08)',
  },
} as const;
